import React, { useState } from "react";
import "./ImageSlider.css";
import { setSingleBlogData, showBlog } from "../../features/serviceSlice";
import { useDispatch, useSelector } from "react-redux";

const ImageSlider = ({ slider = "current_month" }) => {
    const dispatch = useDispatch();
    const getVisibleCount = () => (window.innerWidth <= 680 ? 1 : 3);
    const VISIBLE_COUNT = getVisibleCount();
    const [currentIndex, setCurrentIndex] = useState(0);

    const { isIndividualBlog, blog_data } = useSelector(state => state.service);

    // SAFE DATA ACCESS
    const sliderPosts = blog_data?.[slider]?.posts ?? [];

    const maxIndex = Math.max(sliderPosts.length - VISIBLE_COUNT, 0);

    const slideLeft = () => {
        setCurrentIndex((prev) => Math.max(prev - 1, 0));
    };

    const slideRight = () => {
        setCurrentIndex((prev) => Math.min(prev + 1, maxIndex));
    };

    return (
        <div className="slider-container w-70">

            <button
                className="arrow arrow-left"
                onClick={slideLeft}
                disabled={currentIndex === 0}
            >
                ‹
            </button>

            <div className="slider-viewport">
                <div
                    className="slider-track"
                    style={{
                        transform: `translateX(-${currentIndex * (100 / 2.9)}%)`,
                    }}
                >
                    {sliderPosts.map((x, index) => (
                        <div className="slide" key={index}>
                            <img
                                src={x?.featured_image}
                                onClick={(e) => {
                                    if (!isIndividualBlog) {
                                        e.stopPropagation();
                                        dispatch(showBlog(1));
                                        dispatch(setSingleBlogData(x));
                                    }
                                }}
                                alt={`slide-${index}`}
                            />
                        </div>
                    ))}
                </div>
            </div>

            <button
                className="arrow arrow-right"
                onClick={slideRight}
                disabled={currentIndex === maxIndex}
            >
                ›
            </button>
        </div>
    );
};

export default ImageSlider;
